import { Module } from 'vuex'
import { dbUtils, ExamInfo, ImageInfo, testPrepDB } from './database'
import { formatSeconds } from '@/utils/testprep'
import { likeQuestion } from '@/api/testprep'

// 聊天状态接口
export interface ExamState {
    checkWithImage?: {
        images: ImageInfo[]
    }
}

const state: ExamState = {
    checkWithImage: undefined
}

// Getters
const getters = {
    // 获取聊天图片
    checkWithImage: (state: ExamState) => state.checkWithImage
}

// Mutations
const mutations = {
    SET_CHECK_WITH_IMAGE(state: ExamState, data: { images: ImageInfo[] }) {
        state.checkWithImage = data
    }
}

// Actions
const actions = {
    async initDatabase() {
        try {
            const success = await testPrepDB.initDatabase()

            if (success) {
                // 初始化默认数据
            } else {
                throw new Error('Init database failed')
            }
        } catch (error) {
            console.error('Init database failed:', error)
            throw new Error('Init database failed')
        }
    },
    async createExam({ commit }: any, data: ExamInfo) {
        return dbUtils.createExam(data)
    },
    async getExamDetail({ commit }: any, examId: number) {
        return dbUtils.getExamDetail(examId)
    },
    async updateQuestionCollect({ commit }: any, data: { examId: number; questionId: number; collect: boolean }) {
        likeQuestion({
            questionId: data.questionId,
            likeType: data.collect ? 1 : -1
        })
        return dbUtils.updateQuestionCollect(data)
    },
    async updateQuestionOption({ commit }: any, data: { examId: number; questionId: number; answer: number }) {
        return dbUtils.updateQuestionOption(data)
    },
    async updateExamStatus({ commit }: any, data: { examId: number; status: string }) {
        return dbUtils.updateExamStatus(data)
    },
    async updateExamCostTime({ commit }: any, data: { examId: number; costTime: number }) {
        return dbUtils.updateExamCostTime(data)
    },
    async getTestPrepHistoryList({ commit }: any, pageInfo: any) {
        return dbUtils.getTestPrepHistoryList(pageInfo)
    },
    async getTestPrepHistorySubjectList({ commit }: any, pageInfo: any) {
        return dbUtils.getTestPrepHistorySubjectList(pageInfo)
    },
    async getTestPrepHistoryListBySubjectId({ commit }: any, data: { pageInfo: any; subjectId: string }) {
        return dbUtils.getTestPrepHistoryListBySubjectId(data)
    },
    async getTestPrepFavorateList({ commit }: any, data: { pageInfo: any; subjectId: string }) {
        return dbUtils.getTestPrepFavorateList(data)
    },
    async homeData({ commit }: any) {
        return new Promise(async resolve => {
            try {
                let exam = await dbUtils.getExamListForHomeData(),
                    examCount = exam.length,
                    questionDone = 0,
                    todayQuestionDone = 0,
                    finish = exam.filter(item => item.status == 'completed').length,
                    totalTime = 0

                exam.forEach(item => {
                    totalTime += item.costTime || 0
                    questionDone += item.testList?.filter(item => item.answer !== undefined).length || 0
                    todayQuestionDone +=
                        item.testList?.filter(item => {
                            var time = new Date(item.answerTime || 0)
                            var y = time.getFullYear()
                            var m = time.getMonth()
                            var d = time.getDate()
                            var today = new Date()
                            var todayY = today.getFullYear()
                            var todayM = today.getMonth()
                            var todayD = today.getDate()

                            var isToday = y == todayY && m == todayM && d == todayD

                            return item.answer !== undefined && isToday
                        }).length || 0
                })

                resolve({
                    examCount,
                    questionDone,
                    totalTime: formatSeconds(totalTime / 1000),
                    todayQuestionDone,
                    finish: finish || 0,
                    uncomplated: exam
                        .filter(item => item.status != 'completed')
                        .map((item: ExamInfo) => {
                            let subjects = exam.filter(fItem => fItem.subjectId == item.subjectId),
                                res = 0

                            subjects.forEach((sItem: ExamInfo, sIndex: number) => {
                                if (sItem.id == item.id) {
                                    res = subjects.length - sIndex
                                    return
                                }
                            })

                            return {
                                ...item,
                                showIndex: res
                            }
                        })
                })
            } catch (err) {
                console.error('Ucomlete exam error', err)
            }
        })
    },
    setCheckWithImage({ commit }: any, data: { images: ImageInfo[] }) {
        commit('SET_CHECK_WITH_IMAGE', data)
    }
}

const chatModule: Module<ExamState, any> = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}

export default chatModule
